export const GET_REDIRECTS = 'GET_REDIRECTS'
export const SET_REDIRECTS = 'SET_REDIRECTS'
export const CREATE_REDIRECT = 'CREATE_REDIRECT'
export const REMOVE_REDIRECT = 'REMOVE_REDIRECT'
export const UPDATE_REDIRECT = 'UPDATE_REDIRECT'
export const SET_REDIRECTS_OFFSET_LIMIT = 'SET_REDIRECTS_OFFSET_LIMIT'
export const SET_REDIRECT_ERROR = 'SET_REDIRECT_ERROR'
export const CLEAR_REDIRECT_ERROR = 'CLEAR_REDIRECT_ERROR'
export const SET_BULK_REDIRECTS = 'SET_BULK_REDIRECTS'
export const PROCESS_BULK_UPLOAD = 'PROCESS_BULK_UPLOAD'

export function setError (err) {
  return {
    type: SET_REDIRECT_ERROR,
    payload: { err },
  }
}

export function clearError () {
  return {
    type: CLEAR_REDIRECT_ERROR,
    payload: {},
  }
}

export function getRedirects ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: GET_REDIRECTS,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function setRedirects ({
  storeKey, data, total, processing = false,
}) {
  return {
    type: SET_REDIRECTS,
    payload: {
      storeKey, data, total, processing,
    },
  }
}

export function setBulkRedirects ({ storeKey, data }) {
  return {
    type: SET_BULK_REDIRECTS,
    payload: { storeKey, data },
  }
}

export function processBulkUpload ({ storeKey, data }) {
  return {
    type: PROCESS_BULK_UPLOAD,
    payload: { storeKey, data },
  }
}

export function createRedirect ({ storeKey, data }) {
  return {
    type: CREATE_REDIRECT,
    payload: { storeKey, data },
  }
}

export function updateRedirect ({ storeKey, data }) {
  return {
    type: UPDATE_REDIRECT,
    payload: { storeKey, data },
  }
}

export function removeRedirect ({ storeKey, id }) {
  return {
    type: REMOVE_REDIRECT,
    payload: { storeKey, id },
  }
}

export function setRedirectsOffsetLimit ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: SET_REDIRECTS_OFFSET_LIMIT,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}
